import { 
    GET_STAFF_LIST, GET_STAFF_LIST_FAIL, GET_STAFF_LIST_SUCCESS, 
    GET_BATCH, GET_BATCH_SUCCESS, GET_BATCH_FAIL, 
    GET_BATCH_ORDER, GET_BATCH_ORDER_SUCCESS, GET_BATCH_ORDER_FAIL, 
    CREATE_SUB_BATCH, CREATE_SUB_BATCH_SUCCESS, CREATE_SUB_BATCH_FAIL, 
    GET_DIRECTION, GET_DIRECTION_SUCCESS, GET_DIRECTION_FAIL, 
    GET_DISTRICT, GET_DISTRICT_SUCCESS, GET_DISTRICT_FAIL, 
    GET_DRIVER_ORDER_COUNT, GET_DRIVER_ORDER_COUNT_SUCCESS, GET_DRIVER_ORDER_COUNT_FAIL,
    GET_DRIVER_ORDERS, GET_DRIVER_ORDERS_SUCCESS, GET_DRIVER_ORDERS_FAIL, 
    GET_ROUTE_PLANNED_COUNT, GET_ROUTE_PLANNED_COUNT_SUCCESS, GET_ROUTE_PLANNED_COUNT_FAIL, 
    ASSIGN_ORDER, ASSIGN_ORDER_SUCCESS, ASSIGN_ORDER_FAIL, RESET_ORDERS, 
    GET_DISPATCH_HISTORY_LIST, GET_DISPATCH_HISTORY_LIST_SUCCESS, GET_DISPATCH_HISTORY_LIST_FAIL, CREATE_DISPATCH_HISTORY, CREATE_DISPATCH_HISTORY_SUCCESS, CREATE_DISPATCH_HISTORY_FAIL, GET_BATCH_INFO, GET_BATCH_INFO_SUCCESS, GET_BATCH_INFO_FAIL, UPDATE_DISPATCH_HISTORY, UPDATE_DISPATCH_HISTORY_SUCCESS, UPDATE_DISPATCH_HISTORY_FAIL, GET_ORDERS_STATUS_WEIGHT, GET_ORDERS_STATUS_WEIGHT_SUCCESS, GET_ORDERS_STATUS_WEIGHT_FAIL, HANDLE_FILTER_CHANGE, LOCATION_VERIFY, LOCATION_VERIFY_SUCCESS, LOCATION_VERIFY_FAIL, HANDLE_CURRENT_DRIVER_ID, HANDLE_CURRENT_ROUTE_TYPE, GET_PARTNERS, GET_PARTNERS_SUCCESS, GET_PARTNERS_FAIL
} from "../actions/types";
import _, { parseInt } from 'lodash'
import update from 'immutability-helper';

const initialState = {
    loading: false,
    error: false,
    staff: [],
    staffLoading: false,
    staffError: false,
    batches: [],
    batchesLoading: false,
    batchError: false,
    batchByDistrict: [],
    batchByDistrictLoading: false,
    batchByDistrictError: false,
    isSubBatchSuccess: false,
    subBatchLoading: false,
    subBatchError: false,
    waypoints: [],
    orderList: [],
    districts: {},
    districtLoading: false,
    districtError: false,
    ordersLoading: false,
    ordersError: false,
    ordersByDriver: {},
    dispatchHistory: [],
    dispatchHistoryLoading: false,
    batchInfo: {},
    batchInfoLoading: false,
    updateDispatchHistory: [],
    updateDispatchHistoryLoading: false,
    updateDispatchHistoryError: false,
    filterChange: [],
    driverId: null,
    getPartnersLoading: false,
    getPartners: [],
    getPartnersError: false,
    routeType: 1
}

export default function mmReducer(state = initialState, action){
    switch(action.type){
        case GET_PARTNERS:
            return {
                ...state,
                getPartnersLoading: true
            }
        case GET_PARTNERS_SUCCESS:
            return {
                ...state,
                getPartners: action.payload, 
                getPartnersLoading: false      
            }
        case GET_PARTNERS_FAIL:
            return {
                ...state,
                getPartnersLoading: false,
                getPartnersError: action.payload
            }
        case HANDLE_CURRENT_ROUTE_TYPE:
            return {
                ...state,
                routeType: action.payload
            }
        case HANDLE_CURRENT_DRIVER_ID:
            return {
                ...state,
                driverId: action.payload
            }
        case LOCATION_VERIFY:
            return {
                ...state,
                loading: true
            }
        case LOCATION_VERIFY_SUCCESS:
            let ordersWrongAddr = action.payload.wrong_location_order;
            let orders = _.cloneDeep(state.ordersByDriver);
            let ordersWrongAddrArr = ordersWrongAddr?.split(',');
            let ordersDriver = orders[state.driverId][0];
            if(ordersWrongAddrArr?.length > 0) {
                ordersWrongAddrArr.map((orderId) => {
                    if(orderId) {
                        let index = ordersDriver.findIndex(order=> {return order.order_id === parseInt(orderId)});
                        if(index >= 0) {
                            let temp = ordersDriver[index];
                            ordersDriver.splice(index, 1);
                            ordersDriver.unshift(temp);
                            ordersDriver[0].isWrongLocation = true;
                            orders[state.driverId][0] = ordersDriver;
                        }
                    }
                })
            }
            return {
                ...state,
                loading: false,
                ordersByDriver: orders
            } 
        case LOCATION_VERIFY_FAIL:
            return {
                ...state,
                loading: false
            }
        case UPDATE_DISPATCH_HISTORY:
            return {
                ...state,
                updateDispatchHistoryLoading: true
            }
        case UPDATE_DISPATCH_HISTORY_SUCCESS:
            return {
                ...state,
                updateDispatchHistoryLoading: false,
                updateDispatchHistory: action.payload
            }
        case UPDATE_DISPATCH_HISTORY_FAIL:
            return {
                ...state,
                updateDispatchHistoryLoading: false,
                updateDispatchHistoryError: action.payload
            }
        case GET_STAFF_LIST:
            return {
                ...state,
                staffLoading: true,
                staffError: false
            }
        case GET_STAFF_LIST_SUCCESS:
            return {
                ...state, 
                staffLoading: false,
                staff: action.payload.data
            }
        case GET_STAFF_LIST_FAIL:
            return {
                ...state,
                staffLoading: false,
                staffError: action.payload
            }
        case GET_BATCH:
            return {
                ...state,
                batchesLoading: true
            }
        case GET_BATCH_SUCCESS:
            return {
                ...state,
                batches: action.payload,
                batchesLoading: false
            }
        case GET_BATCH_FAIL:
            return {
                ...state,
                batchesLoading: false,
                batchError: action.payload
            }
        case GET_BATCH_ORDER:
            return {
                ...state,
                batchByDistrictLoading: true
            }
        case GET_BATCH_ORDER_SUCCESS:
            let district = []
            _.map(action.payload.data, function(value, key){
                district.push({id: parseInt(key), orderIds: value})
            })
            return {
                ...state,
                batchByDistrictLoading: false,
                batchByDistrict: district,
                //orderList: action.payload.data.orders
            }
        case GET_BATCH_ORDER_FAIL:
            return {
                ...state,
                batchByDistrictLoading: false,
                batchByDistrictError: action.payload
            }
        case CREATE_SUB_BATCH:
            return {
                ...state,
                subBatchLoading: true,
                subBatchError: false
            }
        case CREATE_SUB_BATCH_SUCCESS:
            let result = false
            if(action.payload.error_code === "OK"){
                result = true
            }
            return {
                ...state,
                subBatchLoading: false,
                isSubBatchSuccess: result
            }
        case CREATE_SUB_BATCH_FAIL:
            return {
                ...state,
                subBatchLoading: false,
                subBatchError: action.payload
            }
        case GET_DIRECTION:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_DIRECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                waypoints: action.payload.data.places
            }
        case GET_DIRECTION_FAIL:
            return {
                ...state,
                loading: false,
                error: true
            }
        case GET_DISTRICT:
            return {
                ...state,
                districtLoading: true,
                districtError: false
            }
        case GET_DISTRICT_SUCCESS:
            window.localStorage.setItem('districts', JSON.stringify(action.payload))
            return {
                ...state,
                districtLoading: false,
                //districts: action.payload
            }
        case GET_DISTRICT_FAIL:
            return {
                ...state,
                districtLoading: false,
                districtError: action.payload
            }
        case GET_DRIVER_ORDER_COUNT:
            return {
                ...state,
                staffLoading: true
            }
        case GET_DRIVER_ORDER_COUNT_SUCCESS:
            let updateArray = action.payload
            let oldArray = _.cloneDeep(state.staff)
            oldArray.map((obj) => {obj['express_count'] = 0; return obj;})
            _.map(updateArray, function(order){
                let index = _.findIndex(oldArray, {'id': order.driver_id})
                if(index !== -1){
                    oldArray[index]['route_planner_distance'] = order.route_planner_distance;
                    oldArray[index]['order_count'] = order.order_count;
                    oldArray[index]['route_planned_count'] = order.route_count;
                    oldArray[index]['express_count'] = 0;
                    if(order.express_count.length > 0) {
                        order.express_count.map((groupBy) => {
                            if(groupBy.type === 1) {
                                oldArray[index]['express_count'] = groupBy.count;
                            }
                        })
                    }
                }
            })
            return {
                ...state,
                staffLoading: false,
                staff: oldArray
            }
        case GET_DRIVER_ORDER_COUNT_FAIL:
            return {
                ...state,
                staffLoading: false
            }
        case GET_ORDERS_STATUS_WEIGHT:
            return {
                ...state,
                staffLoading: true
            }
        case GET_ORDERS_STATUS_WEIGHT_SUCCESS:
            let updateArrayFilter = action.payload
            let oldArrayFilter = _.cloneDeep(state.staff)
            _.map(oldArrayFilter, function(order, index){
                let indexSearch = _.findIndex(updateArrayFilter, {'driver_id': order.id})
                if(indexSearch !== -1){
                    order['route_planner_distance'] = updateArrayFilter[indexSearch].route_planner_distance;
                    order['order_count'] = updateArrayFilter[indexSearch].order_count;
                    order['route_planned_count'] = updateArrayFilter[indexSearch].route_count;
                    order['express_count'] = 0;
                    if(updateArrayFilter[indexSearch].express_count.length > 0) {
                        updateArrayFilter[indexSearch].express_count.map((groupBy) => {
                            if(groupBy.type === 1) {
                                order['express_count'] = groupBy.count;
                            }
                        })
                    }
                } else {
                    order['order_count'] = 0
                    order['route_planned_count'] = 0
                    order['express_count'] = 0
                    order['route_planner_distance'] = 0
                }
            })
            
            return {
                ...state,
                staffLoading: false,
                staff: oldArrayFilter
            }
        case GET_ORDERS_STATUS_WEIGHT_FAIL:
            return {
                ...state,
                staffLoading: false
            }
        case GET_DRIVER_ORDERS:
            return {
                ...state,
                ordersLoading: true
            }
        case GET_DRIVER_ORDERS_SUCCESS:
            let transform = _.transform(action.payload.data.orders, function(result, value, key){
                (result[value.district] || (result[value.district] = [])).push(value)
            }, {})

            let group = {[action.payload.driverId]: transform}
            //Update order_count from staff
            let driverIndex = _.findIndex(state.staff, {'id': Number(action.payload.driverId)})
            let updatedDriver = update(state.staff, {[driverIndex]: {order_count: {$set: action.payload.data.orders.length}}})

            let params = {
                ...state,
                ordersByDriver: _.assign({}, state.ordersByDriver, group),
                ordersLoading: false
            }
            if(window.localStorage.getItem('transfer-all') === '1' && window.localStorage.getItem('weight-status-filter') === '0') {
                params.staff = updatedDriver;
            }
            return params;
        case GET_DRIVER_ORDERS_FAIL:
            return {
                ...state,
                ordersLoading: false,
                ordersError: action.payload
            }
        case GET_ROUTE_PLANNED_COUNT:
            return {
                ...state,
                staffLoading: true
            }
        case GET_ROUTE_PLANNED_COUNT_SUCCESS:
            let a = action.payload
            let b = _.cloneDeep(state.staff)
            _.map(a, function(driver){
                let index = _.findIndex(b, {'id': driver.driver_id})
                if(index !== -1){
                    b[index]['route_planned_count'] = driver.order_count
                }
            })
            return {
                ...state,
                staffLoading: false,
                staff: b
            }
        case GET_ROUTE_PLANNED_COUNT_FAIL:
            return {
                ...state,
                staffLoading: false
            }
        case ASSIGN_ORDER:
            return {
                ...state,
                loading: true
            }
        case ASSIGN_ORDER_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case ASSIGN_ORDER_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_DISPATCH_HISTORY_LIST: 
            return {
                ...state,
                dispatchHistoryLoading: true
            }
        case GET_DISPATCH_HISTORY_LIST_SUCCESS:
            return {
                ...state,
                dispatchHistoryLoading: false,
                dispatchHistory: action.payload.data
            }
        case GET_DISPATCH_HISTORY_LIST_FAIL:
            return {
                ...state,
                dispatchHistoryLoading: false
            }
        case CREATE_DISPATCH_HISTORY:
            return {
                ...state,
                loading: true
            }
        case CREATE_DISPATCH_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false
            }
        case CREATE_DISPATCH_HISTORY_FAIL:
            return {
                ...state,
                loading: false
            }
        case GET_BATCH_INFO:
            return {
                ...state,
                batchInfoLoading: true
            }
        case GET_BATCH_INFO_SUCCESS:
            return {
                ...state,
                batchInfoLoading: false,
                batchInfo: action.payload
            }
        case GET_BATCH_INFO_FAIL:
            return {
                ...state,
                batchInfoLoading: false
            }
        case RESET_ORDERS:
            return {
                ...state,
                batchByDistrict: initialState.batchByDistrict,
                orderList: initialState.orderList,
                ordersByDriver: initialState.ordersByDriver,
                batchInfo: initialState.batchInfo
            }
        case HANDLE_FILTER_CHANGE:
            return {
                ...state,
                filterChange: action.payload
            }
        default: 
            return state;
    }
}